interface DocumentContentSectionProps {
  title: string;
  children: React.ReactNode;
}

export const DocumentContentSection = ({ title, children }: DocumentContentSectionProps) => {
  return (
    <>
      <h2 className="text-lg font-bold mb-4">{title}</h2>
      <div className="w-full border-b-[1.4px] border-primary mb-4" />
      {children}
    </>
  );
};
